import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useAuth from "../../hooks/AuthHook";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { Dropdown } from 'primereact/dropdown';
import { useNavigate, useSearchParams } from "react-router-dom";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { confirmDialog } from 'primereact/confirmdialog';
import useToast from "../../hooks/ToastHook";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const toast = useToast();
    const [ priceTables, setPriceTables ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        retrieve();
    }, [page, limit]);

    const retrieve = () => {
        setLoading(true);
        api.get(`price-tables?page=${page}&limit=${limit}`).then(({ data }) => {
            setPriceTables(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    const remove = (id) => {
        const doRemove = () => {
            setLoading(true);
            api.delete(`price-tables/${id}`).then(() => {
                toast.showSuccess('Removido com sucesso');
                retrieve();
            }).finally(() => setLoading(false));
        }
        confirmDialog({
            message: 'Essa operação não pode ser desfeita, deseja continuar?',
            header: 'Atenção',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: doRemove,
        });
    }

    const actions = table => (
        <>
            <Button icon="pi pi-pencil" className="mr-2" title="Editar" onClick={() => navigate('./' + table.id)}/>
            <Button icon="pi pi-trash" title="Remover" onClick={() => remove(table.id)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    return (
        <div>
            <ConfirmDialog />
            <PageTitle title="Tabelas de preços" subtitle="Crie tabelas de preço personalizadas para cada cliente" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={priceTables} selectionMode="single" emptyMessage="Nada encontrado">
                        <Column field="description" header="Descrição" style={{width:'20%'}}></Column>
                        <Column field="productCount" header="Produtos"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}